import React from 'react';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'gold';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-navy-800 hover:bg-navy-900 text-white shadow-lg hover:shadow-navy-900/30',
    secondary: 'bg-white text-black hover:bg-gray-100',
    outline: 'border-2 border-gold-500 text-gold-500 hover:bg-gold-500/10',
    gold: 'bg-gradient-to-r from-gold-500 via-yellow-400 to-gold-600 text-black font-bold hover:shadow-[0_0_20px_rgba(212,175,55,0.4)] transform hover:-translate-y-0.5'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  return <button className={twMerge(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-608">
      {children}
    </button>;
}